import { selectApiData, selectApiNoContent } from 'util/selector/apiSelector';

import { AxiosInstance } from 'axios';

import { mapProjectSubmitDtoToModel, ProjectSubmitModel } from './dto/ProjectSubmit.dto';

export class ProjectSubmitApi {
  constructor(private client: AxiosInstance) {}

  list(projectId: number): Promise<ProjectSubmitModel[]> {
    return this.client
      .get(`/api/v1/project/${projectId}/submit`)
      .then(selectApiData)
      .then((entries) => entries.map(mapProjectSubmitDtoToModel));
  }

  delete(projectSubmitId: number): Promise<void> {
    return this.client.delete(`/api/v1/project/submit/${projectSubmitId}`).then(selectApiNoContent);
  }
}
